import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

export const connectToLLMDialogStyle: React.CSSProperties = {
    width: TabDialogWidth.width400px,
    height: 'auto'
};
